"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFormQuestionOption = void 0;
const Flag_1 = __importDefault(require("@opsbase/lib-issue/Flag"));
const uuid = __importStar(require("uuid"));
function createFormQuestionOption(o = {}) {
    var _a;
    const id = uuid.v4();
    return Object.assign(Object.assign({ id, value: id, label: '', labelAlt: {}, flag: Flag_1.default.BLACK, score: 0, fail: false }, o), { subQuestions: Object.assign(Object.assign({ sqId: uuid.v4(), enabled: false }, ((o === null || o === void 0 ? void 0 : o.subQuestions) || {})), { questions: [...(((_a = o === null || o === void 0 ? void 0 : o.subQuestions) === null || _a === void 0 ? void 0 : _a.questions) || [])] }) });
}
exports.createFormQuestionOption = createFormQuestionOption;
exports.default = createFormQuestionOption;
